module.exports = __webpack_public_path__ + "img/3.cb60bb8f.png";